import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";

function Report() {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const searchContainerRef = useRef(null);

  const handleSearch = async () => {
    try {
      // Fetch search results from the API
      const response = await axiosInstance.get(
        `/api/products/search/details?name=${searchTerm}`
      );
      setSearchResults(response.data);
    } catch (error) {
      console.error("Error searching products:", error);
    }
  };

  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      // Click occurred outside the search container, clear the search term and results
      setSearchTerm("");
      setSearchResults([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="container mx-auto mt-8 lg:w-full">
        <div
          className="bg-gray-100 mt-20 p-4 rounded-md shadow-md"
          ref={searchContainerRef}
        >
          <label
            htmlFor="search"
            className="block text-sm font-medium text-gray-600"
          >
            Search Product By Name
          </label>
          <div className="flex">
            <input
              type="search"
              id="search"
              name="search"
              placeholder="Search here"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mt-1 p-2 w-full border border-gray-300 rounded-md"
            />
            <button
              type="button"
              className="ml-2 px-4 py-2 bg-amber-500 text-white rounded-md"
              onClick={handleSearch}
            >
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </button>
            <button
              type="button"
              className="ml-2 px-4 py-2 bg-gray-500 text-white rounded-md"
              onClick={() => {
                // Close the search and clear the search term and results
                setSearchTerm("");
                setSearchResults([]);
              }}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>

        {searchResults.length > 0 && (
          <div className="mt-8">
            <h2 className="text-2xl font-bold mb-4">Search Results</h2>
            <ul>
              {searchResults.map((result) => (
                <li key={result.id} className="mb-4 flex flex-col md:flex-row">
                  <div className="md:w-1/4 mb-2 md:mb-0">
                    <img
                      src={`${axiosInstance.defaults.baseURL}/${result.image}`}
                      alt={result.name}
                      className="w-96 h-auto"
                    />
                  </div>
                  <div className="md:w-3/4 md:pl-4">
                    <Link
                      to={`/admin/update/${result._id}`}
                      className="text-blue-500 hover:underline"
                    >
                      <h3 className="text-lg font-semibold">{result.name}</h3>
                      <p className="text-gray-700">{result.price}</p>
                    </Link>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className="bg-gray-200 mt-8 p-4 rounded-md shadow-md sm:flex sm:justify-between">
        <div className="w-full sm:w-1/3 bg-white p-2">
          <p className="text-sm text-gray-600">Products</p>
          <p className="text-xl font-bold">56</p>
        </div>
        <div className="w-full sm:w-1/3 mt-4 sm:mt-0 p-1 bg-white">
          <p className="text-sm text-gray-600">Total Sales</p>
          <p className="text-xl font-bold">10</p>
        </div>
        <div className="w-full sm:w-1/3 mt-4 sm:mt-0 p-1 bg-white">
          <p className="text-sm text-gray-600">Total Cake</p>
          <p className="text-xl font-bold">10</p>
        </div>
      </div>
    </>
  );
}

export default Report;
